import Typography from "@portal/components/atoms/v2/typography";
import { FC } from "react";
import { IRobotHeaderTextProps } from "./types";

const RobotHeaderText: FC<IRobotHeaderTextProps> = ({ text }) => {
  return (
    <>
      <div className="sm:hidden">
        <Typography variant="H3">{text}</Typography>
      </div>
      <div className="hidden sm:flex">
        <Typography variant="H2">{text}</Typography>
      </div>
    </>
  );
};

export default RobotHeaderText;
